<template>
    <td class="table-body-cell whitespace-no-wrap" :class="[ actions.class ? actions.class : '', rowOdd ? 'even' : 'odd' ]">
        <span class="inline-block" v-for="(action, index) in actions.options" v-bind:key="index">

            <router-link v-if="action.type === 'router-link' && canAccess(action, row)"
                class="flex items-center justify-center px-2 py-2 outline-none"
                tag="a"
                :to="routerLink(action)"
                v-tooltip="action.tooltip">
                <font-awesome-icon class="text-sm outline-none"
                    :class="[ action.iconClass, !canAccess(action, row) ? 'opacity-25 cursor-not-allowed' : 'text-gray-700' ]"
                    :icon="['fas', action.icon]" />
            </router-link>
            <button v-else-if="action.type === 'router-link' && !canAccess(action, row)"
                class="flex items-center justify-center px-2 py-2 cursor-default outline-none">
                <font-awesome-icon class="text-sm cursor-default outline-none"
                    :class="[ action.iconClass, !canAccess(action, row) ? 'opacity-25 cursor-not-allowed' : 'text-gray-700' ]"
                    :icon="['fas', action.icon]" />
            </button>
            <button v-if="action.type === 'method' && canAccess(action, row)"
                type="button"
                class="flex items-center justify-center px-2 py-2 outline-none"
                v-on:click="callMethod(action.method, index, item)"
                v-tooltip="action.tooltip">
                <font-awesome-icon class="text-sm outline-none"
                    :class="[ action.iconClass, !canAccess(action, row) ? 'opacity-25 cursor-not-allowed' : 'text-gray-700' ]"
                    :icon="['fas', action.icon]" />
            </button>
            <button v-else-if="action.type === 'method' && !canAccess(action, row)"
                type="button"
                class="flex items-center justify-center px-2 py-2 cursor-default outline-none">
                <font-awesome-icon class="text-sm outline-none"
                    :class="[ action.iconClass, !canAccess(action, row) ? 'opacity-25 cursor-not-allowed' : 'text-gray-700' ]"
                    :icon="['fas', action.icon]" />
            </button>
        </span>
    </td>
</template>

<script>
    export default {
        name: 'Actions',
        props: {
            actions: { type: Object, required: true },
            item: { type: Object, required: true },
            row: { type: Number, required: true },
            resource: { type: String, default: null },
            prefix: { type: String, default: null },
            permissions: { type: Boolean, default: false },
            redirect: { type: Boolean, default: false }
        },
        methods: {
            callMethod: function(method, index, item){
                if (method === 'delete'){
                    let payload = { index: this.row, item: item };
                    this.$emit('delete', payload);
                } else {
                    let payload = { method: method, index: this.row, item: item }
                    this.$emit('action', payload);
                }
            },
            canAccess: function(action){
                if (typeof action.display === 'object'){
                    if (action.display.isset === false){
                        if (this.item[action.display.key] !== null){
                            return false;
                        }
                    } else if (action.display.isset === true){
                        if (!this.item[action.display.key]){
                            return false;
                        }
                    }
                } else {
                    if (action.display === false){
                        return false;
                    }
                }

                if (this.permissions && action.permissions) {
                    if (this.$store.getters.permissions.indexOf(action.permissions) === -1) {
                        return false;
                    }
                }

                return true;
            },
            routerLink(action){
                let url;

                if (action.resource){
                    url = action.resource + '/' + this.item.id + '/' + action.link;
                } else {
                    if (this.prefix){
                        url = this.prefix + this.resource +'/'+ this.item.id +'/'+action.link
                    } else {
                        url = this.resource +'/'+ this.item.id +'/'+action.link
                    }
                }

                if (this.redirect){
                    url = url + '?redirect=true';
                }

                return url;
            }
        },
        computed: {
            rowOdd(){
                return this.row % 2 !== 0;
            },

        }
    }
</script>
